import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { Edit2, Trash2 } from "@piiqtechnologies/svg-icons";
import { PeekButton, PeekDivider, PeekIconButton, PeekSelect, PeekSelectOption, PeekStack, PeekTextField, PeekTooltip, PeekTypography, } from "@piiqtechnologies/ui-components";
import { useAnalytics } from "@piiqtechnologies/ui-lib";
import parentMessages from "../../messages.i18n";
import cardMessages from "../messages.i18n";
import messages from "./messages.i18n";
const MAX_CHARACTERS = 80;
const TIME_OPTIONS = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60];
const TRANSPORT_OPTIONS = [
    { value: "public-transit", labelKey: "publicTransit", displayKey: "allPublicTransit" },
    { value: "walking", labelKey: "walking" },
    { value: "biking", labelKey: "biking" },
    { value: "car", labelKey: "car" },
];
export const CommuteRow = ({ items, defaultCount, onEdit, onDelete, editingNewIndex, onEditingNewHandled, saveTrigger, onEditingCountChange, readOnly, hasBeenRun, }) => {
    const intl = useIntl();
    const analytics = useAnalytics();
    const [editingRows, setEditingRows] = useState({});
    useEffect(() => {
        onEditingCountChange === null || onEditingCountChange === void 0 ? void 0 : onEditingCountChange(Object.keys(editingRows).length);
    }, [editingRows, onEditingCountChange]);
    useEffect(() => {
        if (editingNewIndex !== null && editingNewIndex !== undefined) {
            setEditingRows((prev) => (Object.assign(Object.assign({}, prev), { [editingNewIndex]: { minutes: 40, transportMode: "public-transit", destination: "", isNew: true } })));
            onEditingNewHandled === null || onEditingNewHandled === void 0 ? void 0 : onEditingNewHandled();
        }
    }, [editingNewIndex, onEditingNewHandled]);
    const prevSaveTriggerRef = useRef(saveTrigger);
    useEffect(() => {
        if (saveTrigger === prevSaveTriggerRef.current)
            return;
        prevSaveTriggerRef.current = saveTrigger;
        if (!saveTrigger)
            return;
        Object.entries(editingRows).forEach(([key, row]) => {
            const index = Number(key);
            const trimmedDest = row.destination.trim();
            const isDefault = index < defaultCount;
            if (!trimmedDest && isDefault)
                return;
            if (!trimmedDest && !isDefault) {
                onEdit === null || onEdit === void 0 ? void 0 : onEdit(index, null);
                return;
            }
            onEdit === null || onEdit === void 0 ? void 0 : onEdit(index, { minutes: row.minutes, transportMode: row.transportMode, destination: trimmedDest });
        });
        setEditingRows({});
    }, [saveTrigger, editingRows, defaultCount, onEdit]);
    const handleStartEdit = (index) => {
        analytics.track("Custom Subtopics | Edit Clicked", { category: "Commute", index });
        const item = items[index];
        setEditingRows((prev) => (Object.assign(Object.assign({}, prev), { [index]: {
                minutes: item.minutes,
                transportMode: item.transportMode,
                destination: item.destination,
                isNew: false,
            } })));
    };
    const handleCancelEdit = (index) => {
        const row = editingRows[index];
        analytics.track("Custom Subtopics | Edit Cancelled", { category: "Commute", isNewRow: row === null || row === void 0 ? void 0 : row.isNew });
        if (row === null || row === void 0 ? void 0 : row.isNew) {
            onEdit === null || onEdit === void 0 ? void 0 : onEdit(index, null);
        }
        setEditingRows((prev) => {
            const next = Object.assign({}, prev);
            delete next[index];
            return next;
        });
    };
    const handleDelete = (index) => {
        analytics.track("Custom Subtopics | Subtopic Delete Clicked", { category: "Commute", index });
        onDelete === null || onDelete === void 0 ? void 0 : onDelete(index);
    };
    const getTransportLabel = (mode) => {
        const option = TRANSPORT_OPTIONS.find((o) => o.value === mode);
        if (!option)
            return mode;
        return intl.formatMessage(messages[option.labelKey]);
    };
    const formatDisplayText = (item) => {
        return intl.formatMessage(messages.commuteDisplayFormat, {
            minutes: item.minutes,
            transport: getTransportLabel(item.transportMode).toLowerCase(),
            destination: item.destination,
        });
    };
    return (React.createElement(React.Fragment, null, items.map((item, index) => {
        const isDefault = index < defaultCount;
        const editing = editingRows[index];
        return (React.createElement(React.Fragment, { key: `${index}-${item.destination}` },
            React.createElement(PeekStack, { direction: "row", justifyContent: "space-between", alignItems: "center", width: "100%" },
                React.createElement(PeekStack, { direction: "row", gap: 1, alignItems: "center", flex: 1 },
                    React.createElement(PeekTypography, { variant: "body1" },
                        index + 1,
                        "."),
                    editing ? (React.createElement(PeekStack, { direction: "row", gap: 1, alignItems: "center", flex: 1 },
                        React.createElement(PeekSelect, { value: editing.minutes, onChange: (e) => setEditingRows((prev) => (Object.assign(Object.assign({}, prev), { [index]: Object.assign(Object.assign({}, prev[index]), { minutes: Number(e.target.value) }) }))), size: "small", sx: { minWidth: 130 } }, TIME_OPTIONS.map((time) => (React.createElement(PeekSelectOption, { key: time, value: time },
                            time,
                            " minutes")))),
                        React.createElement(PeekTypography, { variant: "body1", color: "info.main" }, intl.formatMessage(messages.byLabel)),
                        React.createElement(PeekSelect, { value: editing.transportMode, onChange: (e) => setEditingRows((prev) => (Object.assign(Object.assign({}, prev), { [index]: Object.assign(Object.assign({}, prev[index]), { transportMode: e.target.value }) }))), size: "small", sx: { minWidth: 180 } }, TRANSPORT_OPTIONS.map((option) => (React.createElement(PeekSelectOption, { key: option.value, value: option.value }, intl.formatMessage(messages[option.labelKey]))))),
                        React.createElement(PeekTypography, { variant: "body1", color: "info.main" }, intl.formatMessage(messages.toLabel)),
                        React.createElement(PeekTextField, { autoFocus: true, fullWidth: true, size: "small", value: editing.destination, placeholder: intl.formatMessage(messages.destinationPlaceholder), onChange: (e) => {
                                if (e.target.value.length <= MAX_CHARACTERS) {
                                    setEditingRows((prev) => (Object.assign(Object.assign({}, prev), { [index]: Object.assign(Object.assign({}, prev[index]), { destination: e.target.value }) })));
                                }
                            }, inputProps: { maxLength: MAX_CHARACTERS } }))) : (React.createElement(PeekTypography, { variant: "body1" }, formatDisplayText(item)))),
                editing ? (React.createElement(PeekStack, { direction: "row", gap: 1, px: 0.5, alignItems: "center" },
                    React.createElement(PeekTypography, { variant: "body1", color: "info.main" },
                        editing.destination.length,
                        "/",
                        MAX_CHARACTERS),
                    React.createElement(PeekButton, { size: "small", variant: "text", color: "error", onMouseDown: (e) => e.preventDefault(), onClick: () => handleCancelEdit(index) }, intl.formatMessage(messages.cancelButton)))) : (!readOnly && (React.createElement(PeekStack, { direction: "row", gap: 0.5, alignItems: "center" },
                    React.createElement(PeekTooltip, { title: hasBeenRun ? (React.createElement(PeekTypography, { variant: "body1" }, intl.formatMessage(parentMessages.hasBeenRunTooltip, {
                            bold: (chunks) => React.createElement("span", { style: { fontWeight: 500 } }, chunks),
                            br: () => React.createElement("br", null),
                        }))) : (React.createElement(PeekTypography, { variant: "body1" }, intl.formatMessage(cardMessages.editTooltip))) },
                        React.createElement("span", null,
                            React.createElement(PeekIconButton, { onClick: () => handleStartEdit(index), bordered: false, sx: { p: 0.5 }, disabled: hasBeenRun },
                                React.createElement(Edit2, { fontSize: 14 })))),
                    !isDefault && (React.createElement(PeekTooltip, { title: hasBeenRun ? (React.createElement(PeekTypography, { variant: "body1" }, intl.formatMessage(parentMessages.hasBeenRunTooltip, {
                            bold: (chunks) => React.createElement("strong", null, chunks),
                            br: () => React.createElement("br", null),
                        }))) : (React.createElement(PeekTypography, { variant: "body1" }, intl.formatMessage(cardMessages.removeTooltip))) },
                        React.createElement("span", null,
                            React.createElement(PeekIconButton, { onClick: () => handleDelete(index), bordered: false, sx: { p: 0.5 }, disabled: hasBeenRun },
                                React.createElement(Trash2, { fontSize: 14 }))))))))),
            React.createElement(PeekDivider, { light: true })));
    })));
};
